<template>
    <div>
        <nav>
                <ul class="t1-pagination">
                  <li >
                    <a  @click="click">&laquo;</a>
                  </li>
                  <li class="t1-pagination--active">
                    <a  @click="click">1</a>
                  </li>
                   <li  >
                    <a @click="click">2</a>
                  </li>
                   <li >
                    <a @click="click">3</a>
                  </li>
                  <li >
                    <a @click="click"
                      >&raquo;</a>
                  </li>
                </ul>
              </nav>

    </div>
</template>

<script>
export default {
    name: "Pagination"

}
</script>

<style>

</style>